<template>
  <div class="sk-circle" :class="size" :style="{ width: width + 'px', height: height + 'px'}">
    <div class="sk-circle1 sk-child"></div>
    <div class="sk-circle2 sk-child"></div>
    <div class="sk-circle3 sk-child"></div>
    <div class="sk-circle4 sk-child"></div>
    <div class="sk-circle5 sk-child"></div>
    <div class="sk-circle6 sk-child"></div>
    <div class="sk-circle7 sk-child"></div>
    <div class="sk-circle8 sk-child"></div>
    <div class="sk-circle9 sk-child"></div>
    <div class="sk-circle10 sk-child"></div>
    <div class="sk-circle11 sk-child"></div>
    <div class="sk-circle12 sk-child"></div>
  </div>
</template>

<script>
export default {
  name: 'adx-loading-secondary',
  props: {
    size: {
      required: false,
      default: ``
    },
    width: {
      required: false,
      default: 15
    },
    height: {
      required: false,
      default: 15
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>